import React from 'react'
import BookingDoneComp from '../components/BookCourt/BookingDoneComp'

const BookingDone = () => {
  return (
    <> 
 
    <BookingDoneComp/>
  
    </>
  )
}

export default BookingDone